<template>
  <BaseLayout pageTitle="我的律师">
    <div class="lawyer">
      <ServeMe />
      <div class="lawyer-list">
        <ListItem
          v-for="(item, index) in data"
          :key="index"
          :name="item.name"
          :lawOffice="item.lawOffice"
          :serveNum="item.serveNum"
          :popular="item.popular"
          :avatar="item.avatar"
        ></ListItem>
      </div>
    </div>
  </BaseLayout>
</template>

<script>
import { ref } from 'vue'
import { ListItem, ServeMe } from '@/view/lawyer/components'
import jz1Image from '@/assets/jz/1.png'
import jz2Image from '@/assets/jz/2.png'
import jz3Image from '@/assets/jz/3.png'
import jz4Image from '@/assets/jz/4.png'
import jz5Image from '@/assets/jz/5.png'

export default {
  setup(props, { emit }) {
    const data = ref([
      {
        name: '秦向荣',
        lawOffice: '重庆鲲鹏律师事务所',
        time: '2021.08.10 10:40',
        serveNum: '330',
        popular: '民事诉讼一审法律服务产品（原告）',
        avatar: jz1Image,
      },
      {
        name: '林权',
        lawOffice: '重庆鲲鹏律师事务所',
        time: '2021.08.10 10:40',
        serveNum: '300',
        popular: '劳动人事争议仲裁反申请法律服务产品',
        avatar: jz2Image,
      },
      {
        name: '闻芝宇',
        lawOffice: '重庆鲲鹏律师事务所',
        time: '2021.08.10 10:40',
        serveNum: '300',
        popular: '商事仲裁法律服务产品（申请人）',
        avatar: jz3Image,
      },
      {
        name: '徐兴朝',
        lawOffice: '重庆鲲鹏律师事务所',
        time: '2021.08.10 10:40',
        serveNum: '300',
        popular: '民事诉讼一审法律服务产品（原告）',
        avatar: jz4Image,
      },
      {
        name: '简梦寒',
        lawOffice: '重庆鲲鹏律师事务所',
        time: '2021.08.10 10:40',
        serveNum: '300',
        popular: '民事诉讼一审法律服务产品（原告）',
        avatar: jz5Image,
      },
    ])
    return { data }
  },
  components: { ListItem, ServeMe },
}
</script>

<style lang="scss">
.lawyer {
  display: flex;
  flex-direction: column;

  .lawyer-list {
    background-color: #fff;
  }
}
</style>